import axios from 'axios';
import { router } from './router';
import i18n from '@/i18n';
import getApp from './app';

import defines from '../libs/defines';

const api = axios.create({
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
});

api.interceptors.response.use(null, error => {
    let status = error.response.status;
    let app = getApp();

    if (status === defines.RESPONSE_STATUS.UNAUTHORIZED) {
        if (app.$route.name !== 'Login')
            router.push('/login');
        else
            return Promise.reject(error);

        return;
    }

    if (status === defines.RESPONSE_STATUS.FORBIDDEN) {
        router.push('/forbidden');
        return;
    }

    let messageTitle = i18n.t('error.unknownError');
    let returnPage = false;

    switch (error.response.status) {
        case defines.RESPONSE_STATUS.INCORRECT_DATA:
            messageTitle = i18n.t('error.incorrectData');
            break;
        case defines.RESPONSE_STATUS.NOT_FOUND:
            messageTitle = i18n.t('error.notFound');
            break;
        case defines.RESPONSE_STATUS.INTERNAL_SERVER_ERROR:
            messageTitle = i18n.t('error.internalServerError');
            returnPage = true;
            break;
    }

    let description = error.response.data.description || error.request.responseURL;

    if (returnPage)
        router.go(-1);

    app.$nextTick(() => {
        app.toast.error(description, messageTitle, { position: 'bottomRight' });
    });

    return Promise.resolve(null);
});

export default api;
